import { Row } from 'components';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const StyledClickable = (props) => {
  const { isMobile } = useSelector((state) => state.appState);

  return (
    <Row {...props} pos="absolute" ht={isMobile ? '30px' : '60px'} wid={isMobile ? '30px' : '60px'}>
      <a href={props.link}>
        <Row ht={isMobile ? '30px' : '60px'} wid={isMobile ? '30px' : '60px'} />
      </a>
    </Row>
  );
};

const SocialLinks = ({}) => {
  const navigate = useNavigate(),
    { isMobile } = useSelector((state) => state.appState);

  return (
    <Row>
      <Row
        pos="relative"
        bg="red"
        ht="0px"
        wid="0px"
        top={isMobile ? '43px' : '105px'}
        left={isMobile ? '-2px' : '-5px'}
      >
        <StyledClickable link="https://www.linkedin.com/company/playaz4playaz" />

        <StyledClickable
          link="https://www.youtube.com/channel/UCIoXZ_QT_ocjEJJ_a-brW4Q"
          left={isMobile ? '40px' : '80px'}
        />

        <StyledClickable
          link="https://www.instagram.com/playaz4playaz/"
          left={isMobile ? '82px' : '160px'}
        />

        <StyledClickable
          link="https://www.facebook.com/playaz4playaz/"
          left={isMobile ? '120px' : '240px'}
        />

        <StyledClickable link="https://twitter.com/playaz4p" left={isMobile ? '162px' : '315px'} />
      </Row>

      <img
        className="icons-holder"
        src={require('assets/images/sm-icons-placeholder.png')}
        alt=""
      />
    </Row>
  );
};

export default SocialLinks;
